const endpoints = {
  loadSimulationList: (): string => '',
  loadSimulation: (id: string): string => `distributions?strategy=${id}`,
};

export default endpoints;
